import { Fetch } from '../helpers/fetchWrapper';

const authService = {
  auth_url: process.env.REACT_APP_AUTH_API_URL,
  /**
   * Hooks
   */

  async health() {
    const res = await Fetch.get(`${this.auth_url}/health`);
    if (res.status >= 200 && res.status < 300) {
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async login(payload) {
    return await Fetch.post(`${this.auth_url}/user/login`, payload);
  },
  async sendOtp(payload) {
    let res = await Fetch.post(`${this.auth_url}/send-otp`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async verify(payload) {
    let res = await Fetch.post(`${this.auth_url}/verify-otp`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async ChangePassword(payload) {
    let res = await Fetch.patch(`${this.auth_url}/change-password`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async register(payload) {
    return await Fetch.post(`${this.auth_url}/user/register`, payload);
  },
  async getCurrentAdmin() {
    return Fetch.get(`${this.auth_url}/user/details`);
  },
  async updateAdmin(id, values) {
    let res = await Fetch.patch(`${this.auth_url}/update-admin/${id}`, values);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async removeAdminJwt() {
    let res = await Fetch.delete(`${this.auth_url}/logout-user`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
};
export default authService;
